<template>
  <div class="container-fluid w-100 mt-5"
    :class="isModal ? 'aux-cfluid' : ''"
    style="height: 100%; overflow-y: auto; margin: 0 !important;"
  >
    <v-flex v-if="isModal" display-flex flex-column mb-3 align-center justify-center>
      <h3 class="mt-3 mb-2 text-xs-center f-size-32 color-theme-texto font-destaque" v-html="campaignLandingPageConfig ? campaignLandingPageConfig.donationProductsTitle : ''">
      </h3>
    </v-flex>
    <div class="wrapper pb-3" style="height: 100%">
      <v-layout wrap display-flex justify-center style="padding-bottom: 100px;">
        <template v-if="!isModal">
          <button type="button" class="scroll-arrow prev" id="agradPrevArrow">
            <Icon name="far fa-chevron-left" size="16" />
          </button>
          <button type="button" class="scroll-arrow next" id="agradNextArrow">
            <Icon name="far fa-chevron-right" size="16" />
          </button>
          <slick class="bg-white" ref="donationProductsSlick" id="donationProductWrapper"
            :options="slickDonationProductsOptions">
            
            <div v-for="donationProduct in donationProductList" :key="donationProduct.id" class="item">
              <div class="projeto">
                <div class="box-donation-product" :key="donationProduct.id">
                  <div>
                    <img :src="donationProduct.file ? donationProduct.file.path : ''" alt />
                    <h2 class="color-theme-primaria w-100 notranslate">
                      {{ donationProduct.name }}
                    </h2>
                    <h3 class="color-theme-texto notranslate">
                      {{ donationProduct.fixedValue ? FormatterHelper.formatMoney(donationProduct.fixedValue, 2) : ''}}
                    </h3>
                    <p class="notranslate" v-html="donationProduct.description"></p>
                  </div>
                  <div>
                    <button
                      v-if="showDonationButton"
                      type="button"
                      :class="campaignDonationProductAlreadyOnCart(donationProduct.id)
                        ? 'with-check'
                        : ''
                      "
                      value="FormatterHelper.formatMoney(donationProduct.fixedValue, 2) : donationProduct.suggestionValue}}"
                      class="bg-theme-primaria px-5 mt-2 v-btn v-btn--flat v-btn--large v-btn--round theme--light white--text"
                      @click="
                        $gtag(
                          'send',
                          'event',
                          'projetos carrossel',
                          'Quero doar',
                          donationProduct.suggestionValue
                        );
                      "
                    >
                      <Icon name="fas fa-check" class="check-circle" size="18" colorFont="#02ACB4"></Icon>
                      {{
                        campaignLandingPage
                          ? campaignLandingPage.donationButtonText
                          : "Quero doar"
                      }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </slick>
        </template>
        <template v-else>
          <div
            class="box-donation-product"
            v-for="donationProduct in getDonationProductsList"
            :key="donationProduct.id"
          >
            <div v-if="donationProduct.active">
              <img :src="donationProduct.file ? donationProduct.file.path : ''" alt />
              <h2 id="donation-product-name" class="color-theme-primaria">
                {{ donationProduct.name  }}
              </h2>
              <div v-if="donationProduct.initialValue && donationProduct.finalValue">
                <h3 v-if="donationProduct.initialValue === donationProduct.finalValue" class="color-theme-texto notranslate">
                  {{ FormatterHelper.formatMoneyWithCents(donationProduct.initialValue, 2) }}
                </h3>
                <h3 class="color-theme-texto notranslate" v-else-if="donationProduct.finalValue !== '0'">
                  De {{ FormatterHelper.formatMoneyWithCents(donationProduct.initialValue, 2) }}
                  a {{ FormatterHelper.formatMoneyWithCents(donationProduct.finalValue, 2) }}
                </h3>                
                <h3 class="color-theme-texto notranslate" v-else>
                  Mais de {{ FormatterHelper.formatMoneyWithCents(donationProduct.initialValue, 2) }}
                </h3>
                
              </div>
              
              <p class="notranslate" v-html="donationProduct.description"></p>
            </div>
            <div>
              <button
                v-if="showDonationButton && !allowMultiplesTicket"
                type="button"
                :class="
                  campaignDonationProductAlreadyOnCart(donationProduct.id)
                    ? 'with-check'
                    : ''
                  "
                  class="bg-theme-primaria px-5 mt-2 v-btn v-btn--flat v-btn--large v-btn--round theme--light white--text"
                  @click="
                    $gtag(
                      'send',
                      'event',
                      'Produto de doação',
                      'Produto de doação',
                      'Botão quero doar'
                    );
                    addCartItem(donationProduct);
                  "
                >
                  <Icon name="fas fa-check" class="check-circle" size="18" colorFont="#02ACB4"></Icon>
                  {{
                    campaignLandingPage
                      ? campaignLandingPage.donationButtonText
                      : "Quero doar"
                  }}
              </button>
              <div class="number-combo" 
                v-if="showDonationButton && allowMultiplesTicket" 
                style="justify-content: center !important; align-items: center !important;">
                <button 
                  style="width: 25px; height: 44px; margin-top: 0 !important;"
                  @click="removeTickets(donationProduct)">
                    <i class="fal fa-minus"></i>
                </button>
                <div class="t-center" >
                  <input
                    v-model="donationProduct.quantity"
                    style="width: 60px; height: 44px" id="sizeWindow" type="number" min="0"
                      max="99999" />
                </div>
                <button 
                  style="width: 25px; height: 44px; margin-top: 0 !important;"
                    @click="addTickets(donationProduct)">
                    <i class="fal fa-plus"></i>
                </button>
                <div class="t-center ml-3" >
                  <div class="value-cart-field value-cart-field-br"
                      style="width: auto; padding: 0;">
                      <input style="border: 0 none; height: 44px; width: auto; outline: none;"
                          id="sizeWindow" type="number" min="0" max="9999999" readonly
                          v-model="donationProduct.value"
                          />
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <div
            v-if="isModal && allowMultiplesTicket"
            style="
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              background: white;
              padding: 16px;
              box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
              z-index: 10;"
          >
            <button
              type="button"
              class="bg-theme-primaria px-5 v-btn v-btn--flat v-btn--large v-btn--round theme--light white--text w-100"
              @click="addDonationsProducts()"
            >
              Adicionar ao carrinho
            </button>
          </div>
          
        </template>
      </v-layout>
    </div>
  </div>
</template>
<script type="plain/text">
import CampaignService from "@/scripts/services/campaign.service"
import { ProjectTypes } from "@/scripts/models/enums/projectTypes.enum";
import FormatterHelper from "@/scripts/helpers/formatter.helper";
import DonationProduct from "@/scripts/models/donationProduct.model";
import Project from "@/scripts/models/project.model";
import cartStorageService from "@/scripts/services/cartStorage.service";
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    donationProductList: [DonationProduct],
    project: { type: Project, default: new Project() },
    showDonationButton: Boolean,
    isModal: Boolean,
  },
  data() {
    return {
      campaignService: new CampaignService(),
      selectedDonationProduct: null,
      ProjectTypes: ProjectTypes,
      FormatterHelper: new FormatterHelper(),
      coinSelected: "R$ ",
      projectList: [],
      cart: null,
      donationProductListLocal: [],
      slickDonationProductsOptions: {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        prevArrow: "#agradPrevArrow",
        nextArrow: "#agradNextArrow",
        responsive: [
          {
            breakpoint: 1900,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 730,
            settings: {
              slidesToShow: 1,
              arrows: false,
              centerMode: true,
              centerPadding: "30px",
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters([
      "campaignLandingPageConfig",
      "campaignDonationProductAlreadyOnCart",
      "itemToAdd",
      "logged"
    ]),
    allowMultiplesTicket() {
      return this.campaignLandingPageConfig?.campaign?.allowMultiplesTicket ?? false;
    },
    getDonationProductsList() {
      return this.donationProductListLocal
        .filter((x) => x.active)
    },
  },
  watch: {
    donationProductList: {
      handler(newList) {
        this.cart = cartStorageService.getCart();
        if (Array.isArray(newList)) {
          this.donationProductListLocal = newList.map(item => ({
            ...item,
            quantity: item.quantity ?? 0,
            value: 0
          }));

          
          this.getCartQuantity();
        }
      },
      immediate: true
    },
  },
  async created() {
    if (!this.campaignLandingPageConfig?.id)
      await this.setLandingPageConfig()

    this.campaignService
      .getCampaignProjectList(this.campaignLandingPageConfig.campaign.id)
      .then((projectList) => {
        this.projectList = projectList
      });

    if (this.campaignLandingPageConfig?.campaign?.allowUsdDonation)
      this.coinSelected = "US$ ";

    this.showDonationButton = true;
    this.setItemToAdd(null);
  },
  methods: {
    ...mapActions([
      "alterCampaignDonationProduct",
      "addToCart",
      "setItemToAdd",
      "setLandingPageConfig",
      "refreshCart",
      "removeToCart",
    ]),
    getCartQuantity() {
      this.donationProductListLocal.forEach((item) => {
          if (this.cart && this.cart.cartItems.length) {
            const index = this.cart.cartItems.findIndex((c) => {
              return item.id === c.donationProductId;
            })
            
            if (index != -1) {
              this.$set(item, 'quantity', this.cart.cartItems[index]?.donationProduct.quantity);
              this.$set(item, 'value', (this.cart.cartItems[index]?.donationProduct.fixedValue * this.cart.cartItems[index]?.donationProduct.quantity));
            }
          }
        
      });
    },
    removeItem(donationProductId){
      if (this.cart && this.cart.cartItems.length) {
        const cartItem = this.cart.cartItems.find((c) => c.donationProductId === donationProductId);

        if (cartItem) {
          this.removeToCart(cartItem);
        }
      }
    },
    addDonationsProducts() {
      const products = this.donationProductListLocal
        .filter((x) => x.quantity > 0)

        this.addCartItem(products);
    },
    addTickets(donationProduct) {
      donationProduct.quantity++;
      donationProduct.value = donationProduct.fixedValue * donationProduct.quantity;
    },
    removeTickets(donationProduct) {
      donationProduct.quantity = Math.max(0, donationProduct.quantity - 1)
      donationProduct.value = donationProduct.fixedValue * donationProduct.quantity

      if (donationProduct.quantity === 0) {
        this.removeItem(donationProduct.id);
      }
    },
    openConfirmDonationToDonationProductModal(item) {
      this.addCampaignDonationProductToCart(item);
      this.end();
    },
    addCampaignDonationProductToCart(donationProduct) {
      //this.alterCampaignDonationProduct(donationProduct.id)

      this.addToCart({
        project: null,
        campaignProduct: donationProduct
      })
    },
    end() {
      if (this.isModal) this.$emit("close");

      if (this.itemToAdd) {
        document.getElementById("animation-proj").classList.add("active");
        setTimeout(() => {
          document.getElementById("animation-proj").classList.remove("active");
        }, 2000);
      }

      this.setItemToAdd(null);
    },
    async addCartItem(campaignProduct = null) {
      if (!this.itemToAdd){
        return this.openConfirmDonationToDonationProductModal(campaignProduct);
      }

      if (campaignProduct && campaignProduct.id && this.logged)
        this.alterCampaignDonationProduct(campaignProduct.id);

      const isCheckoutV1 = this.campaignLandingPageConfig.campaign.useLegacyProductFramework

      if(!isCheckoutV1) {
        this.addToCart({
          project: this.itemToAdd,
          campaignProduct: campaignProduct
        });
      } else if (isCheckoutV1 && this.allowMultiplesTicket) {
        this.addToCart({
          project: this.itemToAdd,
          donationProduct: campaignProduct,
        });
      } else {
        this.addToCart({
          project: this.itemToAdd,
          donationProduct: campaignProduct,
        });
      }
      await this.refreshCart();
      this.cart = cartStorageService.getCart();
      
      this.end();      
    },
  },
};
</script>